/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/*
 * Author M. Atoar Rahman
 * Title: Pending Internal Request Table
 * Description: Pending Internal Request Table
 * Date: 05/06/2022
 */

import moment from 'moment';
import { useCallback, useEffect } from 'react';
import { Badge, Button } from 'react-bootstrap';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useDataTable from '../../../hooks/useDataTable';
import UrlService from '../../../services/UrlService';
import { useApproval } from './ContextAPI';

export default function ApprovedTable() {
    const { setShow, setRowData, approvedData, getApprovedData } = useApproval();
    const axiosPrivate = useAxiosPrivate();

    const handleShow = async (row) => {
        try {
            const response = await axiosPrivate.get(
                UrlService.getInternalRequestByIdAndCentralWarehouseUrl(
                    row.id,
                    row.central_warehouse_id
                ),
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            );

            const row_info = {
                master_id: row.id,
                partner_name: row.partner_name,
                facility_name: row.facility_name,
                partner_id: row.partner_id,
                facility_id: row.facility_id,
                status: row.status,
                records: response?.data?.internal_request_details_info,
            };
            setRowData(row_info);
            setShow(true);
        } catch (err) {
            if (!err?.response) {
                console.log('Server Not Responding!');
            } else if (err.response?.status === 401) {
                console.log('Unauthorized!');
            } else {
                console.log('Data Not Found!');
            }
        }
    };

    const dataList = useCallback(() => {
        getApprovedData();
    }, []);

    useEffect(() => {
        dataList();
    }, [dataList]);

    const columns = [
        {
            name: 'Facility',
            selector: (row) => row.facility_name,
            sortable: true,
            grow: 3,
        },
        {
            name: 'Submitted Date',
            selector: (row) => row.approve_date,
            format: (row) =>
                row.approve_date ? moment(row.approve_date).format('DD MMM YYYY') : '',
            sortable: true,
        },
        {
            name: 'Status',
            sortable: true,
            cell: (row) =>
                row.status === 'partner_distributed' ? (
                    <Badge className="badgeActive" bg="success">
                        Partner Distributing
                    </Badge>
                ) : row.status === 'partner_distribute_apv' ? (
                    <Badge className="badgeActive" bg="success">
                        Partner Distributed
                    </Badge>
                ) : row.status === 'partner_forwarded' ? (
                    <Badge className="badgeActive" bg="success">
                        Partner Forwarding
                    </Badge>
                ) : row.status === 'partner_forward_apv' ? (
                    <Badge className="badgeActive" bg="success">
                        Partner Forwarded
                    </Badge>
                ) : row.status === 'unhcr_received' ? (
                    <Badge className="badgeActive" bg="success">
                        UNHCR Received
                    </Badge>
                ) : row.status === 'unhcr_approved' ? (
                    <Badge className="badgeActive" bg="success">
                        UNHCR Approved
                    </Badge>
                ) : row.status === 'center_received' ? (
                    <Badge className="badgeActive" bg="success">
                        Central Received
                    </Badge>
                ) : row.status === 'center_distributed' ? (
                    <Badge className="badgeActive" bg="success">
                        Central Distributed
                    </Badge>
                ) : row.status === 'partner_received' ? (
                    <Badge className="badgeActive" bg="success">
                        Partner Receiving
                    </Badge>
                ) : row.status === 'partner_receive_apv' ? (
                    <Badge className="badgeActive" bg="success">
                        Partner Received
                    </Badge>
                ) : row.status === 'facility_received' ? (
                    <Badge className="badgeActive" bg="success">
                        Facility Receiving
                    </Badge>
                ) : row.status === 'facility_receive_apv' ? (
                    <Badge className="badgeActive" bg="success">
                        Facility Received
                    </Badge>
                ) : (
                    <Badge className="badgeInactive" bg="success">
                        Pending
                    </Badge>
                ),
        },
        {
            name: 'Action',
            selector: (row) => row.action,
            cell: (row) => (
                <Button
                    onClick={() => handleShow(row)}
                    className="btnSuccess"
                    type="button"
                    variant="success"
                >
                    View
                </Button>
            ),
        },
    ];

    const search_column = {
        // facility_name: 'Facility',
        // submited_date: 'Submited Date',
    };
    return useDataTable({ columns, data: approvedData, search_column, pagination: false });
}
